import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

import { connect } from 'react-redux';
import { useFormik } from 'formik';
import { notification } from 'antd';

import { BACKEND_URL_QUOTATION } from 'Config/routes';

import ModalGenerateSolicitudExpedicionView from './ModalGenerateSolicitudExpedicionView';

const DEFAULT_ERROR_MESSAGE = 'Ha ocurrido un problema inesperado. Si el problema persiste, revise la información e intente nuevamente.';

const ModalGenerateSolicitudExpedicion = (props) => {
  const {
    visible,
    quotationId,
    onCloseModal,
    aseguradoras,
    onSuccess, // Se llama cuando la acción se completó con éxito, en este caso, cuando se genera lasolicitud de expedición
    sedes,
    vendedores,
  } = props;

  const [stateQuotation, setStateQuotation] = useState({
    quotationData: {},
    selectedPackages: [],
    selectedPackage: null, // Paquete seleccionado por el cliente :)
  });
  const [isFetching, setIsFetching] = useState(false);
  const [messageError, setMessageError] = useState('');
  const [sedesUserCreateQuotation, setSedesUserCreateQuotation] = useState([]);

  const formikForm = useFormik({
    initialValues: {
      sede: '',
      vendedor: null,
      vendedor_name: null,
      observaciones: '',
    },
    validate: (values/* , props */) => {
      const errors = {};
      const requiredFields = ['sede', 'vendedor'];
      requiredFields.forEach((requiredField) => {
        if (!values[requiredField]) errors[requiredField] = 'Este campo es requerido';
      });
      return errors;
    },
    onSubmit: (values) => {
      if (!stateQuotation.selectedPackage) return;

      setIsFetching(true);
      setMessageError('');

      axios.post(`${BACKEND_URL_QUOTATION}${quotationId}/generate_solicitud_expedicion/`,
        {
          sede: values.sede,
          vendedor: values.vendedor,
          selected_package: stateQuotation.selectedPackage.id,
          observaciones: values.observaciones,
        },
        {
          headers: {
            Authorization: `Token ${localStorage.getItem('token')}`,
          },
        })
        .then((response) => {
          notification.success({
            message: 'Solicitud de expedición creada exitosamente',
            description: `Número de cotización: ${response.data.softseguros_quotation_number}`,
          });
          onSuccess(response.data.softseguros_quotation_number);
        })
        .catch((error) => {
          const errorMessage = (
            <>
              <strong>Solicitud de expedición no generada</strong><br />
              {error.response?.data?.message || DEFAULT_ERROR_MESSAGE}
            </>
          );
          setMessageError(errorMessage);
        })
        .finally(() => {
          setIsFetching(false);
        });
    },
  });

  useEffect(() => {
    setIsFetching(true);
    setMessageError('');

    axios.get(`${BACKEND_URL_QUOTATION}${quotationId}/`, {
      headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
      },
    })
      .then((response) => {
        const selectedPackages = response.data.insurance_carrier_quotations.filter((item) => item.selected).map((item) => ({
          ...item,
          insuranceCarrierFiltered: aseguradoras.find((aseguradora) => aseguradora.id === item.insurance_carrier),
        }));

        if (!selectedPackages.length) {
          setMessageError('Esta cotización no cuenta con paquetes seleccionados.');
          return;
        }

        // Filtrar en los paquetes para hallar el seleccionado por defecto
        const clienteSelectionPackage = selectedPackages.find((item) => item.client_preference);

        // Sede Usuarios
        const sedeUsuarios = sedes.filter((sede) => response.data.created_by_data.sedes.includes(sede.id));
        setSedesUserCreateQuotation(sedeUsuarios);

        // Actualizar algunos valores necesarios en el formulario
        const sedeId = response.data.created_by_data.sedes.find(() => response.data.created_by_data.sedes.length === 1);

        const observacion = response.data.vehicle_data.is_new ? 'Vehículo cero kilómetros.\n' : '';

        formikForm.setValues({
          vendedor: response.data.created_by_data.softseguros_vendedor_id,
          vendedor_name: response.data.created_by_data.softseguros_vendedor_nombre,
          sede: sedeId,
          observaciones: observacion,
        });

        setStateQuotation({
          ...stateQuotation,
          quotationData: response.data,
          selectedPackages,
          selectedPackage: clienteSelectionPackage, // || selectedPackages[0],
        });
      })
      .catch((error) => {
        const errorMessage = (
          <>
            <strong>No se pudo obtener la cotización</strong><br />
            {error.response?.data?.message || DEFAULT_ERROR_MESSAGE}
          </>
        );
        setMessageError(errorMessage);
      })
      .finally(() => {
        setIsFetching(false);
      });
  }, []);

  const handleChangePackageSelection = (e) => {
    const newSelectedPackage = stateQuotation.selectedPackages.find((item) => item.id === e.target.value);
    setStateQuotation({
      ...stateQuotation,
      selectedPackage: newSelectedPackage,
    });
  };

  return (
    <ModalGenerateSolicitudExpedicionView
      visible={visible}
      loading={isFetching}
      messageError={messageError}
      form={formikForm}

      // quotation={stateQuotation.quotationData}
      sedes={sedesUserCreateQuotation}
      packages={stateQuotation.selectedPackages}
      selectedPackage={stateQuotation.selectedPackage}
      vendedores={vendedores}

      handleSendModal={formikForm.submitForm}
      onCloseModal={onCloseModal}
      handleChangeSelectedPackage={handleChangePackageSelection}
    />
  );
};

ModalGenerateSolicitudExpedicion.defaultProps = {
  visible: false,
  onCloseModal: () => { },
  onSuccess: () => {},
};

ModalGenerateSolicitudExpedicion.propTypes = {
  visible: PropTypes.bool,
  quotationId: PropTypes.string.isRequired,
  onCloseModal: PropTypes.func,
  aseguradoras: PropTypes.array.isRequired,
  onSuccess: PropTypes.func,
};

const mapStateToProps = (state) => {
  let vendedores = [];
  if (state?.initialData?.user?.perfil === 1) vendedores = state.softsegurosVendedores.vendedores;

  return {
    aseguradoras: state.initialData.aseguradoras,
    sedes: state.initialData.sedes,
    vendedores,
  };
};
export default connect(mapStateToProps)(ModalGenerateSolicitudExpedicion);
